import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { WidgetOption } from '../../displayer.utils';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

type InputSelectConfig = {
    name: string;
    placeholder: string;
};

export const InputSelect =
    (options: WidgetOption[], config: InputSelectConfig) =>
    // eslint-disable-next-line react/display-name
    <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
        const InputSelectExtended = commonComponentsRegistry.getLazyComponent('InputSelectExtended');
        return (
            <InputSelectExtended
                {...props}
                {...config}
                name={props.name}
                htmlFor={`displayer-field-${config.name}`}
                searchable={options.length > 12}
                getLabel={(option: WidgetOption) => `${option.label}`}
                getValue={(option: WidgetOption) => `${option.value}`}
                getSearch={(option: WidgetOption) => `${option.label}`}
                options={options}
                rules={{ required: props.mandatory }}
                margin={props.margin}
            />
        );
    };
